import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    updateVacApp,
    detailsVacApp,
} from "../actions/vaccineAppointmentActions";
import { useUpdateAppointment } from "./api/app";
import showToast from "../utils/toast";

const bdiQuestions = [
  {
    text: 'Sadness',
    options: [
      "I do not feel sad.",
      "I feel sad much of the time.",
      "I am sad all the time.",
      "I am so sad or unhappy that I can't stand it."
    ]
  },
  {
    text: 'Pessimism',
    options: [
      "I am not discouraged about my future.",
      "I feel more discouraged about my future than I used to.",
      "I do not expect things to work out for me.",
      "I feel my future is hopeless and will only get worse."
    ]
  },
  {
    text: 'Past Failure',
    options: [
      "I do not feel like a failure.",
      "I have failed more than I should have.",
      "As I look back, I see a lot of failures.",
      "I feel I am a total failure as a person."
    ]
  },
  {
    text: 'Loss of Pleasure',
    options: [
      "I get as much pleasure as I ever did from the things I enjoy.",
      "I don't enjoy things as much as I used to.",
      "I get very little pleasure from the things I used to enjoy.",
      "I can't get any pleasure from the things I used to enjoy."
    ]
  },
  {
    text: 'Guilty Feelings',
    options: [
      "I don't feel particularly guilty.",
      "I feel guilty over many things I have done or should have done.",
      "I feel quite guilty most of the time.",
      "I feel guilty all of the time."
    ]
  },
  {
    text: 'Punishment Feelings',
    options: [
      "I don't feel I am being punished.",
      "I feel I may be punished.",
      "I expect to be punished.",
      "I feel I am being punished."
    ]
  },
  {
    text: 'Self-Dislike',
    options: [
      "I feel the same about myself as ever.",
      "I have lost confidence in myself.",
      "I am disappointed in myself.",
      "I dislike myself."
    ]
  },
  {
    text: 'Self-Criticalness',
    options: [
      "I don't criticize or blame myself more than usual.",
      "I am more critical of myself than I used to be.",
      "I criticize myself for all of my faults.",
      "I blame myself for everything bad that happens."
    ]
  },
  {
    text: 'Suicidal Thoughts or Wishes',
    options: [
      "I don't have any thoughts of killing myself.",
      "I have thoughts of killing myself, but I would not carry them out.",
      "I would like to kill myself.",
      "I would kill myself if I had the chance."
    ]
  },
  {
    text: 'Crying',
    options: [
      "I don't cry anymore than I used to.",
      "I cry more than I used to.",
      "I cry over every little thing.",
      "I feel like crying, but I can't."
    ]
  },
  {
    text: 'Agitation',
    options: [
      "I am no more restless or wound up than usual.",
      "I feel more restless or wound up than usual.",
      "I am so restless or agitated, it's hard to stay still.",
      "I am so restless or agitated that I have to keep moving or doing something."
    ]
  },
  {
    text: 'Loss of Interest',
    options: [
      "I have not lost interest in other people or activities.",
      "I am less interested in other people or things than before.",
      "I have lost most of my interest in other people or things.",
      "It's hard to get interested in anything."
    ]
  },
  {
    text: 'Indecisiveness',
    options: [
      "I make decisions about as well as ever.",
      "I find it more difficult to make decisions than usual.",
      "I have much greater difficulty in making decisions than I used to.",
      "I have trouble making any decisions."
    ]
  },
  {
    text: 'Worthlessness',
    options: [
      "I do not feel I am worthless.",
      "I don't consider myself as worthwhile and useful as I used to.",
      "I feel more worthless as compared to others.",
      "I feel utterly worthless."
    ]
  },
  {
    text: 'Loss of Energy',
    options: [
      "I have as much energy as ever.",
      "I have less energy than I used to have.",
      "I don't have enough energy to do very much.",
      "I don't have enough energy to do anything."
    ]
  },
  {
    text: 'Changes in Sleeping Pattern',
    options: [
      "I have not experienced any change in my sleeping.",
      "I sleep somewhat more than usual.",
      "I sleep somewhat less than usual.",
      "I sleep a lot more than usual.",
      "I sleep a lot less than usual.",
      "I sleep most of the day.",
      "I wake up 1-2 hours early and can't get back to sleep."
    ]
  },
  {
    text: 'Irritability',
    options: [
      "I am not more irritable than usual.",
      "I am more irritable than usual.",
      "I am much more irritable than usual.",
      "I am irritable all the time."
    ]
  },
  {
    text: 'Changes in Appetite',
    options: [
      "I have not experienced any change in my appetite.",
      "My appetite is somewhat less than usual.",
      "My appetite is somewhat greater than usual.",
      "My appetite is much less than before.",
      "My appetite is much greater than usual.",
      "I have no appetite at all.",
      "I crave food all the time."
    ]
  },
  {
    text: 'Concentration Difficulty',
    options: [
      "I can concentrate as well as ever.",
      "I can't concentrate as well as usual.",
      "It's hard to keep my mind on anything for very long.",
      "I find I can't concentrate on anything."
    ]
  },
  {
    text: 'Tiredness or Fatigue',
    options: [
      "I am no more tired or fatigued than usual.",
      "I get more tired or fatigued more easily than usual.",
      "I am too tired or fatigued to do a lot of the things I used to do.",
      "I am too tired or fatigued to do most of the things I used to do."
    ]
  },
  {
    text: 'Loss of Interest in Sex',
    options: [
      "I have not noticed any recent change in my interest in sex.",
      "I am less interested in sex than I used to be.",
      "I am much less interested in sex now.",
      "I have lost interest in sex completely."
    ]
  }
];

const BDI = () => {
 const [formData, setFormData] = useState({});
  const [existingData, setExistingData] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const vaccineAppList = useSelector((state) => state.vaccineAppDetails);
  const { appointment: { appointment, pastAppointments } = {} } = vaccineAppList || {};
  const updateAccData = useUpdateAppointment();

  useEffect(() => {
    dispatch(detailsVacApp(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (appointment && appointment.bdi) {
      setExistingData(appointment?.bdi?.info);
    }
  }, [appointment]);

  useEffect(() => {
    if (existingData) {
      setFormData(existingData);
    }
  }, [existingData]);

  const handleChange = (qIndex, value) => {
    setFormData({ ...formData, [qIndex]: value });
  };

  const totalScore = Object.values(formData).reduce(
    (sum, val) => sum + (val !== null ? parseInt(val) : 0),
    0
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    // Save score to localStorage for Psychodiagnostic form
    const localStorageKey = `psycho_tools_${id}`;
    const existingScores = JSON.parse(localStorage.getItem(localStorageKey) || '{}');
    existingScores['BDI'] = totalScore;
    localStorage.setItem(localStorageKey, JSON.stringify(existingScores));

    updateAccData.mutate({
      _id: appointment._id,
      bdi: {
        info: formData,
        score: totalScore
      }
    });

    dispatch(detailsVacApp(id));
    showToast("You have successfully submitted the form.");
  };
  return (
   <form onSubmit={handleSubmit} style={{ maxWidth: 800, margin: '0 auto', padding: 20 }}>
      <h1>Beck's Depression Inventory (BDI-II)</h1>
      <p>Please choose the option that best describes how you've felt in the past two weeks, including today.</p>

      {bdiQuestions.map((q, index) => (
        <div key={index} style={{ marginBottom: 20 }}>
          <h3>{index + 1}. {q.text}</h3>
          {q.options.map((option, optIndex) => (
            <div key={optIndex}>
              <label>
                <input
                  type="radio"
                  name={`question-${index}`}
                  value={optIndex}
                  checked={formData[index] === optIndex}
                  onChange={() => handleChange(index, optIndex)}
                />
                {` (${optIndex}) ${option}`}
              </label>
            </div>
          ))}
        </div>
      ))}

      <h2>Total Score: {totalScore}</h2>
      <button type="submit">Submit</button>
    </form>
  
  )
}

export default BDI